import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { UserDashboardOnlyGuard } from './core/guards/user-dashboard-only.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'monitoramento'
  },
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth-module').then(m => m.AuthModule)
  },
  {
    path: 'monitoramento',
    canMatch: [AuthGuard],
    loadChildren: () => import('./features/monitoramento/monitoramento-module').then(m => m.MonitoramentoModule)
  },
  {
    path: 'relatorio',
    canMatch: [AuthGuard, UserDashboardOnlyGuard],
    loadChildren: () => import('./features/relatorio/relatorio-module').then(m => m.RelatorioModule)
  },
  {
    path: 'gerenciamento',
    canMatch: [AuthGuard, UserDashboardOnlyGuard],
    loadChildren: () => import('./features/gerenciamento/gerenciamento-module').then(m => m.GerenciamentoModule)
  },
  {
    path: 'suporte',
    canMatch: [AuthGuard, UserDashboardOnlyGuard],
    loadChildren: () => import('./features/suporte/suporte-module').then(m => m.SuporteModule)
  },
  {
    path: '**',
    redirectTo: 'monitoramento'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
